import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import "./jsonModal.scss";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css";
import Paper from "@mui/material/Paper";
export default function BasicModal({ isOpen, handleClose, data }) {
  var JSONPrettyMon = require("react-json-pretty/dist/monikai");

  return (
    <div>
      <Modal
        className="json-modal"
        open={isOpen}
        onClose={handleClose}
        disableBackdropClick
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth={false}
      >
        <Box component={Paper} className="jsonViewerModal">
          <JSONPretty
            id="json-pretty"
            theme={JSONPrettyMon}
            data={data}
          ></JSONPretty>
        </Box>
      </Modal>
    </div>
  );
}
